export enum VendorZoneTypes {
  Pincode = 'pincode',
  State = 'state',
  Country = 'country',
}
